const comments = [
  { name: '追剧达人小王', text: '自从发现番茄影视大全，追剧再也不用到处找资源了。更新速度超快，画质清晰还不卡顿，强烈推荐给所有剧迷朋友！', time: '2天前', stars: 5 },
  { name: '电影爱好者阿杰', text: '院线大片上线速度惊人，看完《飞驰人生2》全程高清无缓冲，体验完全不输影院。已经安利给身边所有朋友了。', time: '3天前', stars: 5 },
  { name: '陪娃妈妈小丽', text: '少儿专区的内容质量很高，孩子看动画片我放心。没有乱七八糟的广告，界面也干净，真的是良心平台。', time: '4天前', stars: 5 },
  { name: '综艺铁粉老陈', text: '每周末必刷综艺，番茄影视的综艺更新最快最全。《歌手2024》每期都不落下，高清画质看舞台表演太过瘾了。', time: '5天前', stars: 4 },
  { name: '纪录片迷小李', text: '纪录片资源太丰富了，BBC和Discovery的经典系列都有。画质清晰，翻译质量高，足不出户就能看遍世界。', time: '6天前', stars: 5 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">用户口碑</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自真实用户的观影反馈，好平台用口碑说话
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.map((c, i) => (
            <div
              key={i}
              className={`rounded-2xl p-6 md:p-7 border transition-all duration-300 ${
                i === 0
                  ? 'lg:col-span-2 bg-primary-50 border-primary-100'
                  : 'bg-background-100 border-background-200/70'
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, s) => (
                  <i
                    key={s}
                    className={`text-sm ${s < c.stars ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">&ldquo;{c.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                    <span className="text-sm font-bold text-secondary-700">{c.name.charAt(0)}</span>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{c.name}</span>
                </div>
                <span className="text-xs text-foreground-500">{c.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}